import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type { ColumnType } from 'antd/es/table';

import { DragButton } from '@/shared/components';

import type { IAbilityItemData } from './types';

export const getColumnsData = ({
  openEditAbilityModal,
  openDeleteAbilityModal,
  setItemToOperate,
}: {
  openEditAbilityModal: VoidFunction;
  openDeleteAbilityModal: VoidFunction;
  setItemToOperate: (data: IAbilityItemData | null) => void;
}) =>
  [
    {
      title: 'Наименование навыка',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
    },
    {
      title: 'Описание навыка',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 216,
      render: (_, { id, title, position, description }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <DragButton rowKey={position} />
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, title, position, description });
              openEditAbilityModal();
            }}
          >
            <EditOutlined style={{ fontSize: '20px' }} />
          </Button>
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, title, position, description });
              openDeleteAbilityModal();
            }}
          >
            <DeleteOutlined style={{ fontSize: '20px' }} />
          </Button>
        </div>
      ),
      fixed: 'right',
    },
  ] as ColumnType<IAbilityItemData>[];
